import { useMemo } from "react";
import { BlockData, BlockType } from "@/api/block";

export function useBlockTree(blocks: BlockData[]) {
	return useMemo(() => {
		const blockMap = new Map<string, BlockData>();
		const childrenMap = new Map<string, BlockData[]>();

		// Single pass: build block lookup and children map
		for (const block of blocks) {
			blockMap.set(block.id, block);
		}

		for (const block of blocks) {
			for (const targetId of block.target) {
				const child = blockMap.get(targetId);
				if (child) {
					const existing = childrenMap.get(block.id);
					if (existing) {
						existing.push(child);
					} else {
						childrenMap.set(block.id, [child]);
					}
				}
			}
		}

		const markets = blocks.filter((b) => b.type === BlockType.MARKET);

		return {
			markets,
			childrenOf: (blockId: string): BlockData[] => childrenMap.get(blockId) || [],
			blockById: (blockId: string): BlockData | undefined => blockMap.get(blockId),
		};
	}, [blocks]);
}
